import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import CompetitionBadge from './CompetitionBadge';
import { isEntrantJudge, isAlsoViewer } from '../utils/roles';

export default function ContestantHeader() {
  const { user, logout } = useAuth();
  const { pathname }     = useLocation();

  // Dashboard only — see the note in JudgeHeader. This header is also on the
  // submit, payment and profile pages.
  const showSwitch = isEntrantJudge(user) && pathname === '/contestant/dashboard';
  // Granted the results page (Viewers panel) on top of entering.
  const showResults = isAlsoViewer(user) && pathname === '/contestant/dashboard';

  return (
    <>
      <header className="c-header">
        <div className="c-header__brand">
          <Link to="/contestant/dashboard" className="c-header__logo">
            <span className="scala">SCALA</span>{' '}
            <span className="c-header__logo-sub">Song Competition</span>
            <CompetitionBadge />
          </Link>
        </div>

        <div className="c-header__right">
          <span className="c-header__user">{user?.full_name}</span>
          <button onClick={logout} className="c-header__logout">
            Sign out
          </button>
        </div>
      </header>

      {/* Mirror of the judge header's switcher — same three people, other side. */}
      {showSwitch && (
        <div className="c-roleswitch">
          <span className="c-roleswitch__label">You are also a FOOM judge</span>
          <Link to="/judge/dashboard" className="c-btn c-roleswitch__btn">
            Switch to judge view →
          </Link>
        </div>
      )}

      {showResults && (
        <div className="c-roleswitch">
          <span className="c-roleswitch__label">You have access to the FOOM results</span>
          <Link to="/viewer/results" className="c-btn c-roleswitch__btn">
            FOOM results →
          </Link>
        </div>
      )}

      {/* Contestants weren't finding the old "Profile" link in the header bar,
          so it now sits below the bar as a full-size button. */}
      <div className="c-subnav">
        <Link to="/contestant/profile" className="c-btn c-btn--green">
          My Profile
        </Link>
      </div>
    </>
  );
}
